export default keyValuePairs => {
    return Object.keys(keyValuePairs).map(key => ({
        key,
        value: key,
        label: keyValuePairs[key],
    }));
};
